import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const ValentinesTnC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: '20px', color: '#FFFFFF' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <button className="back-button" style={{ paddingLeft: '0px' }} onClick={() => navigate('/home')}>
          <FiChevronLeft className="back-button-icon" />
        </button>
      </div>
      <h2 style={{ marginTop: '20px', color: '#FFFFFF' }}>Terms and Conditions</h2>
      <p>
        This contest ("Five Years of GoSats Campaign") is being run and organised by Saffroncoin Technologies Pvt Ltd
        ("GoSats", "Organizer") on mobile application, ie. GoSats.
      </p>
      <br />
      <p className="text">ELIGIBILITY</p>
      <p>To participate in the Contest, you must fulfil the following</p>
      <ol>
        <li>Age must be 18 years and above;</li>
        <li>You should be an individual legal resident of the Republic of India;</li>
        <li>Must have a valid registered account on the GoSats platform and log into the same;</li>
        <li>
          This contest is not available in the state of Tamil Nadu in view of the provisions of the Tamil Nadu Prize
          Scheme (Prohibition) Act, 1979 or any other place where this is prohibited by law;
        </li>
        <li>
          Employees of the Organizer shall not be eligible for any of the prizes/rewards/gratification under this Contest.
          For the purpose of this clause, Employees shall mean those persons who are managing and operating the Contest.
        </li>
      </ol>
      <br />
      <p>WINNER SELECTION AND REWARDS</p>
      <p>This is specified in the contest section of the GoSats mobile application. Please refer to the same.</p>
      <br />
      <p className="text">TERMS AND CONDITIONS</p>
      <p>
        The participation in the Contest is open only for the Contest Period for the Indian citizens of age 18 years and
        above. Participants who are residents (permanent/temporary) of any state/union territory within the territory of
        India, wherever such Contest is prohibited by applicable law, shall not be entitled to participate in this
        Contest.
      </p>
      <br />
      <p>
        By participating in the Contest, participants consent to the Terms of Use, Privacy Policy and other relevant
        documentation published on the Platform. Organizer reserves the right to extend, cancel, discontinue, or modify
        this Contest at their sole discretion. The prizes/rewards under this Contest are neither assignable nor
        transferable. For the complete terms and conditions, please refer to the standard contest terms available on the
        GoSats platform.
      </p>
      <br />
      <p className="text">IMPLIED CONSENT</p>
      <p>
        By participating in this contest, user ("You", "Your" or "Participant") agrees to be bound by: these terms and
        conditions ("T&C"); the Terms of Use, Privacy Policy and other relevant documentation including any modifications,
        alterations or updates thereof, that are published on the Platform.
      </p>
    </div>
  );
};

export default ValentinesTnC;
